const TooltipValueTitle = require('./TooltipValueTitle');

module.exports = TooltipValueTitle;
